import { Box, SimpleGrid, Skeleton, VStack } from "@chakra-ui/react";
import React from "react";

interface AssessmentSkeletonLoaderProps {
  /**
   * Number of skeleton cards to display
   * @default 6
   */
  cardCount?: number;
  /**
   * Number of columns in the grid
   * @default { base: 1, md: 3 }
   */
  columns?: { base?: number; md?: number };
}

const AssessmentSkeletonLoader: React.FC<AssessmentSkeletonLoaderProps> = ({
  cardCount = 6,
  columns = { base: 1, md: 3 },
}) => {
  return (
    <SimpleGrid columns={columns} spacing={4} alignItems="stretch">
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box key={index} borderRadius="8px" border="1px solid #E5E7EB" p={6}>
          <VStack spacing={3} align="stretch">
            <Skeleton height="15px" borderRadius="md" />
            <Skeleton height="15px" width="80%" borderRadius="md" />
            <Skeleton height="15px" width="90%" borderRadius="md" />
            <Skeleton height="15px" width="70%" borderRadius="md" />
            <Skeleton height="15px" width="85%" borderRadius="md" />
            <Skeleton height="15px" width="60%" borderRadius="md" />
          </VStack>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default AssessmentSkeletonLoader;
